import { CmBox, CmFlex, CmInput, CmText, CmVStack } from '@/components/uiParts';

type ColorSettingsProps = {
  color: string;
  onChangeColorHandler: (color: string) => void;
};

export const ColorSetting: React.FC<ColorSettingsProps> = (props) => {
  const { color, onChangeColorHandler } = props;

  return (
    <CmVStack spacing={8} align="stretch">
      <CmBox>
        <CmFlex align="center" mb={2}>
          <CmText fontSize="md" fontWeight="medium">
            メインカラー設定
          </CmText>
          <CmText fontSize="xs" color="red.500" ml={2}>
            必須
          </CmText>
        </CmFlex>
        <CmInput
          value={color}
          onChange={(e) => onChangeColorHandler(e.target.value)}
          placeholder="#000000"
          maxW="420px"
          mb={3}
        />
        <CmBox
          w="100%"
          maxW="320px"
          h="150px"
          bg={color}
          borderRadius="md"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CmText
            color="white"
            bg="rgba(0,0,0,0.3)"
            px={3}
            py={1}
            borderRadius="md"
            fontSize="md"
          >
            {color}
          </CmText>
        </CmBox>
      </CmBox>
    </CmVStack>
  );
};
